document.addEventListener("DOMContentLoaded", () => {
  // STYCKY PRODUCT TYPES FILTERS
  const productTypesFilters = document.getElementById("product-types-filters");
  const infoBarElement = document.querySelector(".byteex-info-bar");
  const headerMenuElement = document.getElementById("byteex-header-nav");
  const announcementElement = document.getElementById("byteex-announcement-snippet");

  let infoBarHeight = 0;
  let headerMenuHeight = 0;
  let announcementHeight = 0;
  let scrollUpHeight = 0;
  let scrollDownHeight = 0;
  let lastScroll = 0;

  function updateHeights() {
    infoBarHeight = infoBarElement ? infoBarElement.getBoundingClientRect().height : 0;
    headerMenuHeight = headerMenuElement ? headerMenuElement.getBoundingClientRect().height : 0;
    announcementHeight = announcementElement ? announcementElement.getBoundingClientRect().height : 0;

    scrollUpHeight = infoBarHeight + announcementHeight;
    scrollDownHeight = infoBarHeight + headerMenuHeight + announcementHeight;
  }

  updateHeights();

  window.addEventListener("resize", updateHeights);
  window.addEventListener("orientationchange", updateHeights);

  if (productTypesFilters) {
    window.addEventListener("scroll", () => {
      const currentScroll = window.scrollY;

      if (currentScroll > lastScroll) {
        productTypesFilters.style.top = `${scrollUpHeight}px`;
      } else {
        productTypesFilters.style.top = `${scrollDownHeight}px`;
      }

      lastScroll = currentScroll;
    });
  }


  // RATING REVIEWS COUNT
  function ratingReviewsCount() {
    const productRatings = document.querySelectorAll(".collection-product-rating");
    productRatings.forEach(rating => {
      const html = rating.innerHTML;
      const reviews = html.split('data-number-of-reviews="')[1].split('"')[0];
      if (+reviews > 0) {
        rating.querySelector(".collection-product-rating-reviews-count").textContent = `(${reviews})`;
      }
    });
  }

  ratingReviewsCount();

  // PRODUCT TITLE BLUR
  function productTitleBlur() {
    const productTitles = document.querySelectorAll(".collection-product-title");
    productTitles.forEach(title => {
      const title_wrapper_width = title.offsetWidth;

      const title_text = title.querySelector("a");
      const title_width = title_text.getBoundingClientRect().width;

      const title_blur = title.querySelector("div");

      if (title_width > title_wrapper_width) {
        title_blur.classList.remove("hidden");
      }
    });
  }

  productTitleBlur();

  // APPLY DISCOUNTS TO PRODUCTS  
  let discountProductsData = '';
  let discountCollectionsData = '';
  let currencySymbol = '';

  // function for loading discount data
  function loadDiscountData() {
    const discountElement = document.getElementById('discount-data');
    if (discountElement) {
      discountProductsData = discountElement.dataset.products || '';
      discountCollectionsData = discountElement.dataset.collections || '';
      currencySymbol = discountElement.dataset.currency || '';
    }
  }

  loadDiscountData();

  // function for applying discounts to products
  function applyDiscountsToProducts() {
    if (!discountProductsData && !discountCollectionsData) return;

    const productCards = document.querySelectorAll('.product-card');
    productCards.forEach(card => {
      const productId = card.dataset.productId;
      if (!productId) return;

      const discountInfo = getDiscountForProduct(productId);
      if (discountInfo) {
        applyDiscountToCard(card, discountInfo);
      }
    });
  }

  // function for getting discount for a specific product
  function getDiscountForProduct(productId) {
    const productIdString = productId + '/';

    if (discountProductsData.includes(productIdString)) {
      const discountItems = discountProductsData.split('||');
      for (const item of discountItems) {
        if (item.includes(productIdString)) {
          const parts = item.split('/');
          return {
            today: parts[1],
            discount_start: parts[2],
            discount_end: parts[3],
            discount_percent: parts[4],
            discount_fixed_amount: parts[5],
            discount_text: parts[6]
          };
        }
      }
    }

    if (discountCollectionsData.includes(productIdString)) {
      const discountItems = discountCollectionsData.split('||');
      for (const item of discountItems) {
        if (item.includes(productIdString)) {
          const parts = item.split('/');
          return {
            today: parts[1],
            discount_start: parts[2],
            discount_end: parts[3],
            discount_percent: parts[4],
            discount_fixed_amount: parts[5],
            discount_text: parts[6]
          };
        }
      }
    }

    return null;
  }

  // function for applying discount to a product card
  function applyDiscountToCard(card, discountInfo) {
    const productPrice = card.querySelector('.product-card-price');
    const productComparePrice = card.querySelector('.product-card-compare-price');
    const productDiscountBadge = card.querySelector('.product-card-discount-badge');
    const productPriceValue = +productPrice.dataset.price;

    if (discountInfo.discount_percent) {
      const discountValue = discountInfo.discount_percent;
      const discountPriceValue = productPriceValue * (1 - discountValue / 100);
      productPrice.textContent = `${currencySymbol}${(discountPriceValue / 100).toFixed(2)}`;

      if (productDiscountBadge) {
        productDiscountBadge.classList.remove("hidden");
        productDiscountBadge.textContent = `${discountInfo.discount_text} ${discountInfo.discount_percent}%`;
      }
    }

    if (discountInfo.discount_fixed_amount) {
      const discountValue = discountInfo.discount_fixed_amount;
      const discountPriceValue = productPriceValue - discountValue * 100;
      productPrice.textContent = `${currencySymbol}${(discountPriceValue / 100).toFixed(2)}`;

      if (productDiscountBadge) {
        productDiscountBadge.classList.remove("hidden");
        productDiscountBadge.textContent = `${discountInfo.discount_text} ${currencySymbol}${discountInfo.discount_fixed_amount}`;
      }
    }

    if (productComparePrice) {
      productComparePrice.classList.remove("hidden");
      productComparePrice.textContent = `${currencySymbol}${(productPriceValue / 100).toFixed(2)}`;
    }
  }

  applyDiscountsToProducts();

  // PRODUCT TYPE FILTER
  const products_grid_wrapper = document.querySelector(".product-grid-wrapper");
  const productTypeFilters = document.querySelectorAll(".product-type-filter");

  productTypeFilters.forEach((button, index, array) => {
    button.addEventListener("click", () => {
      const filterValue = button.dataset.type;

      const spinnerLoaderFilters = document.querySelector(".collection-spinner-loader-filters");
      spinnerLoaderFilters.classList.remove("hidden");
      spinnerLoaderFilters.classList.add("flex");
      products_grid_wrapper.style.display = "none";

      array.forEach(btn => btn.classList.remove("product-type-filter-active"));
      button.classList.add("product-type-filter-active");

      const baseUrl = window.location.pathname;

      let url = "";
      if (filterValue.toLowerCase() === "all") {
        //url = `${baseUrl}?view=clearance-sale`;
        url = `${baseUrl}`;
      } else {
        url = `${baseUrl}?filter.p.m.custom.product_type_filter=${encodeURIComponent(filterValue)}`;
        //url = `${baseUrl}?view=clearance-sale&filter.p.product_type=${encodeURIComponent(filterValue)}`;
      }

      fetch(url)
        .then(res => res.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, "text/html");

          const newProducts = doc.querySelector(".product-grid-wrapper");
          if (newProducts) {
            products_grid_wrapper.innerHTML = newProducts.innerHTML;
          }

          loadMoreObserver();

          // change url in address bar
          //window.history.pushState({}, "", url);
        })
        .catch(err => {
          console.error("Error loading filter:", err);
        })
        .finally(() => {
          spinnerLoaderFilters.classList.add("hidden");
          spinnerLoaderFilters.classList.remove("flex");
          products_grid_wrapper.style.display = "block";

          ratingReviewsCount();
          productTitleBlur();
          applyDiscountsToProducts();

          if (typeof addToCartFormListeners === 'function') {
            addToCartFormListeners();
          }
        });
    });
  });

  // LOAD MORE FUNCTIONALITY
  let observer = null;
  function loadMoreObserver() {
    const load_more_button = document.querySelector(".collection-load-more-button");
    const spinnerLoaderMore = document.querySelector(".collection-spinner-loader-more");

    if (observer) {
      observer.disconnect();
      observer = null;
    }

    if (load_more_button) {
      observer = new IntersectionObserver(async (entries, obs) => {
        const entry = entries[0];
        if (!entry.isIntersecting) return;

        load_more_button.style.display = "none";
        spinnerLoaderMore.classList.remove("hidden");
        spinnerLoaderMore.classList.add("flex");

        const res = await fetch(load_more_button.dataset.url);
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, "text/html");

        // add the products cards
        const newProducts = doc.querySelectorAll(".product-grid .product-card");
        newProducts.forEach(p => document.querySelector(".product-grid").appendChild(p));

        // update the button
        const new_load_more_button = doc.querySelector(".collection-load-more-button");
        if (new_load_more_button) {
          load_more_button.dataset.url = new_load_more_button.dataset.url;
          load_more_button.style.display = "block";
        } else {
          load_more_button.remove();
          obs.disconnect(); // disconnect the observer if there are no more pages
        }

        ratingReviewsCount();
        productTitleBlur();
        applyDiscountsToProducts();

        if (typeof addToCartFormListeners === 'function') {
          addToCartFormListeners();
        }

        spinnerLoaderMore.classList.add("hidden");
        spinnerLoaderMore.classList.remove("flex");
      }, {
        rootMargin: "50px", // start loading 50px before the button
      });

      observer.observe(load_more_button);
    } else {
      ratingReviewsCount();
      productTitleBlur();
    }
  }

  const load_more_button_click = document.querySelector(".collection-load-more-button");
  if (load_more_button_click) {
    load_more_button_click.addEventListener("click", () => {
      loadMoreObserver();
    });
  }

  loadMoreObserver();
});
